/* eslint-disable camelcase */
import { AnyAction } from 'redux'
import {
  FETCH_FIRST_BOOKING_ITEMS,
  FETCH_FIRST_SEARCH_ITEMS,
  FETCH_NEIGHBOURHOODS,
  FETCH_PLACE_ITEMS,
  FETCH_SEARCH_ITEMS,
  SET_BASIC_FILTERS,
  SET_FILTERS,
} from '../actions/types'
import { BasicFiltersActionProps, BasicFiltersStateProps } from '../types'
import { ProductListRecord } from '@/components/reusable/productCard/types'

export interface SearchStateProps {
  list: ProductListRecord[] | null
  map_list?: ProductListRecord[]
  midterm_map_list?: ProductListRecord[] | null
  loading: boolean
  pagination: {
    total: number
    current_page: number
  }
  region_data?: {
    city: string
    title: string
    description: string
    province?: string
    village?: string
    faqs?: {
      question: string
      answer: string
    }[]
    tags?: {
      link: string
      name: string
    }[]
  } | null
  min_price?: {
    amount: string
    currency_name: string
    currency_short_form: string
  }
  parent?: {
    title?: string
    city?: string
  }
  search_id?: string
  firstLoading?: boolean
}

interface SearchActionProps extends SearchStateProps {
  type: string
  firstLoading?: boolean
}

export const search = (
  state: SearchStateProps = {
    list: null,
    map_list: [],
    midterm_map_list: null,
    loading: false,
    region_data: null,
    pagination: {
      total: 0,
      current_page: 0,
    },
    search_id: '',
  },
  {
    type,
    list,
    map_list,
    midterm_map_list,
    loading,
    pagination,
    min_price,
    region_data,
    parent,
    search_id,
  }: SearchActionProps,
): SearchStateProps => {
  switch (type) {
    case FETCH_SEARCH_ITEMS:
      return {
        list,
        loading,
        pagination,
        region_data,
        min_price,
        parent,
        search_id,
        map_list,
        midterm_map_list,
      }
    default:
      return state
  }
}

export const firstSearch = (
  state: SearchStateProps = {
    list: null,
    map_list: [],
    loading: false,
    region_data: null,
    pagination: {
      total: 0,
      current_page: 0,
    },
    search_id: '',
    firstLoading: false,
  },
  {
    type,
    list,
    map_list,
    loading,
    pagination,
    min_price,
    region_data,
    parent,
    search_id,
    firstLoading,
  }: SearchActionProps,
): SearchStateProps => {
  switch (type) {
    case FETCH_FIRST_SEARCH_ITEMS:
      return {
        list,
        loading,
        pagination,
        region_data,
        min_price,
        parent,
        search_id,
        map_list,
        firstLoading,
      }
    default:
      return state
  }
}
// export interface FirstSearchType {
//   data: any
//   loading: boolean
//   page: number
// }
// export const firstSearch = (
//   state: FirstSearchType = {
//     data: null,
//     loading: false,
//     page: 1,
//   },
//   action,
// ) => {
//   switch (action.type) {
//     case FETCH_FIRST_SEARCH_ITEMS:
//       return {
//         ...state,
//         data: action.data,
//         loading: action.loading,
//       }
//   }
// }
export const firstBookingOff = (
  state: SearchStateProps = {
    list: [],
    loading: false,
    region_data: null,
    pagination: {
      total: 0,
      current_page: 0,
    },
  },
  {
    type,
    list,
    loading,
    pagination,
    min_price,
    region_data,
    parent,
  }: SearchActionProps,
): SearchStateProps => {
  switch (type) {
    case FETCH_FIRST_BOOKING_ITEMS:
      return { list, loading, pagination, region_data, min_price, parent }

    default:
      return state
  }
}

export interface MainFilters {
  phrase?: string
  city?: string[]
  near_cities?: string[]
  province?: string[]
  village?: string
  area_type?: string
  min_price?: string
  max_price?: string
  just_open_houses?: string
  perpage?: string
  page?: string
  from_timestamp?: string
  with?: string[]
  features?: string[]
  checking_timestamp?: string
  checkout_timestamp?: string
  guests?: string
  type?: {
    [key: string]: string
  }
  is_instanct?: string
  is_mehman_navaz?: string
  is_mehman_navaz_recently?: string
  random?: string
  tag?: string[]
  'co_ordinates[max_latitude]'?: string
  'co_ordinates[max_longitude]'?: string
  'co_ordinates[min_latitude]'?: string
  'co_ordinates[min_longitude]'?: string
  'user_co_ordinates[latitude]'?: string
  'user_co_ordinates[longitude]'?: string
  late_night?: string
  bed_count?: string
  bedroom_count?: string
  first_reservation?: string
  cancel?: string
  parent_id?: string
  host_uid?: string
  price_guarantee?: string
  long_term_discount?: string
  has_watermarked_photo?: string
  nearby?: string
  cottage?: string
}

export const defaultSearchFilters: MainFilters = {
  phrase: '',
  city: [],
  near_cities: [],
  province: [],
  village: '',
  area_type: '',
  min_price: '',
  max_price: '',
  just_open_houses: '',
  perpage: '',
  page: '',
  from_timestamp: '',
  with: [],
  features: [],
  checking_timestamp: '',
  checkout_timestamp: '',
  guests: '',
  type: {},
  is_instanct: '',
  is_mehman_navaz: '',
  is_mehman_navaz_recently: '',
  random: '',
  tag: [],
  'co_ordinates[max_latitude]': '',
  'co_ordinates[max_longitude]': '',
  'co_ordinates[min_latitude]': '',
  'co_ordinates[min_longitude]': '',
  'user_co_ordinates[latitude]': '',
  'user_co_ordinates[longitude]': '',
  late_night: '',
  bed_count: '',
  bedroom_count: '',
  first_reservation: '',
  cancel: '',
  parent_id: '',
  host_uid: '',
  price_guarantee: '',
  long_term_discount: '',
  has_watermarked_photo: '',
  nearby: '',
  cottage: '',
}

export const searchFilters = (
  state: MainFilters = defaultSearchFilters,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_FILTERS:
      return { ...state, ...action.filters }

    default:
      return state
  }
}

export const basicFilters = (
  state: BasicFiltersStateProps = {
    checkin: null,
    checkout: null,
    guests: 0,
  },
  { checkin, checkout, guests, type }: BasicFiltersActionProps,
): BasicFiltersStateProps => {
  switch (type) {
    case SET_BASIC_FILTERS:
      return {
        ...state,
        checkin,
        checkout,
        guests,
      }

    default:
      return state
  }
}

interface PlaceType {
  query_parameters: string[]
  label: string
}
interface PlaceItem {
  name: string
  label: string
  query_parameters: string[]
  icon: { [key: string]: string }
  places: PlaceType[]
}
export interface PlaceFilter {
  data: PlaceItem[] | null
  loading: boolean
}
export const placeFilter = (
  state: PlaceFilter = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_PLACE_ITEMS:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}
const neighbourhoodsInitial = {
  list: null,
  searchList: null,
}
export interface NeighbourhoodsTypes {
  data: { list: string[] | null; searchList: string[] | null }
  loading: boolean
}
export const neighbourhoodsReducer = (
  state: NeighbourhoodsTypes = { data: neighbourhoodsInitial, loading: false },
  { type, data, loading },
) => {
  switch (type) {
    case FETCH_NEIGHBOURHOODS:
      return { ...state, data, loading }
    default:
      return state
  }
}
